import * as React from "react";
import { Box, Tooltip } from "@mui/material";
import PauseIcon from "@mui/icons-material/Pause";
import PropTypes from "prop-types";

export const PausedIndicator = ({ size = 22 }) => (
    <Tooltip title="Currently paused">
        <Box
            sx={{
                width: size,
                height: size,
                bgcolor: "error.main",
                color: "common.white",
                borderRadius: "4px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
            }}
        >
            <PauseIcon sx={{ fontSize: size - 6 }} />
        </Box>
    </Tooltip>
);

PausedIndicator.propTypes = {
    size: PropTypes.number,
};
